interface focusablesData {
  focusables: NodeListOf<HTMLElement>,
  focusIndex: number
}

export const getFocusables = (container: HTMLElement, currentFocus: HTMLElement): focusablesData => {
  // Get focusables in container
  const focusables = container.querySelectorAll('button:not([tabindex="-1"]):not([disabled]), [tabindex]:not([tabindex="-1"])') as NodeListOf<HTMLElement>
  // Get current focus index
  let focusIndex = 0
  for (let i = 0; i < focusables.length; i++) {
    if (focusables[i] === currentFocus) {
      focusIndex = i
      break
    }
  }
  // Focus data
  return {
    focusables,
    focusIndex
  }
}
